import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-slide-over-footer',
  templateUrl: './slide-over-footer.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SlideOverFooterComponent {}
